import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { SnackbarService } from 'src/app/shared/components/snackbar/service/snackbar.service';
import { WindowScrollService } from 'src/app/core/services/window-scroll.service';
import { MediaModel } from '../../../core/models/attachment.model';

@Component({
  selector: 'app-products-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss']
})
export class MediaComponent implements OnInit {

  @ViewChild('uploadBtnRef', { read: ElementRef, static: true }) uploadBtn: ElementRef;
  @ViewChild('gridUploadBtnRef', { read: ElementRef, static: true }) gridUploadBtn: ElementRef;
  @ViewChild('gridUploadBtn2Ref', { read: ElementRef, static: true }) gridUploadBtn2: ElementRef;

  @ViewChild('uploadBtnRefFull', { read: ElementRef, static: true }) uploadBtnFull: ElementRef;
  @ViewChild('gridUploadBtnRefFull', { read: ElementRef, static: true }) gridUploadBtnFull: ElementRef;
  @ViewChild('gridUploadBtn2RefFull', { read: ElementRef, static: true }) gridUploadBtn2Full: ElementRef;

  @ViewChild('uploadFileBtnRef', { read: ElementRef, static: true }) uploadFileBtn: ElementRef;
  @ViewChild('gridUploadFileBtnRef', { read: ElementRef, static: true }) gridUploadFileBtn: ElementRef;
  @ViewChild('gridUploadFileBtn2Ref', { read: ElementRef, static: true }) gridUploadFileBtn2: ElementRef;

  get hasCheckedPhoto(): boolean {
    for (const photo of this.attachedPhotosSession) {
      if (photo.marked) {
        return true;
      }
    }
    return false;
  }

  get allPhotosChecked(): boolean {
    for (const photo of this.attachedPhotosSession) {
      if (!photo.marked) {
        return false;
      }
    }
    return true;
  }

  showFullPhotoManager = false;

  attachedPhotosSession: MediaModel[] = [];
  attachedFilesSession: MediaModel[] = [];

  videosArray = [];
  toursArray = [];

  maxPhotos = 25;
  maxFiles = 10;

  allowedExtensionsPhoto = [
    'jpg',
    'jpeg',
    'png',
    'tiff'
  ];

  allowedExtensionsFile = [
    'doc',
    'docx',
    'pdf',
    'ppt',
    'pptx',
    'xls',
    'xlsx'
  ];

  private iconExt = {
    doc: 'word',
    docx: 'word',
    pdf: 'pdf',
    ppt: 'powerpoint',
    pptx: 'powerpoint',
    xls: 'excel',
    xlsx: 'excel'
  };

  public mockReorder = [ '01', '02', '03', '04', '05', '...mock' ];
  public mockClassification = [ 'Área de serviço', 'Cozinha', 'Sala de estar', '...mock' ];

  constructor(private snackSvc: SnackbarService,
              private windowService: WindowScrollService) { }

  ngOnInit(): void { }

  async verifyPhotos(source: string) {
    const photosArray: File[] = this.getSourcePhotos(source);
    for (const photo of photosArray) {
      const fileExtension = photo.name.split('.').pop().toLowerCase();
      if (this.allowedExtensionsPhoto.includes(fileExtension)) {
        if (photo.size < 2097153) {
          const icon: string = this.iconExt[fileExtension] || null;
          const readFile = await this.getBase64(photo);
          if (this.attachedPhotosSession.length < this.maxPhotos) {
            if (this.verifyDuplicatePhoto(readFile)) {
              this.attachedPhotosSession.push({
                name: photo.name,
                file: photo,
                fileExt: fileExtension,
                icon,
                content_type: photo.type,
                content: readFile
              });
            } else {
              this.snackSvc.show('Foto duplicada.', 'error');
            }
          } else {
            this.snackSvc.show('Limite de fotos atingido.', 'error');
          }
        } else {
          this.snackSvc.show('Limite máximo por foto é de 2MB.', 'error');
        }
      } else {
        this.snackSvc.show('Tipo de arquivo não permitido.', 'error');
      }
    }
    this.clearPhotoInputs();
  }

  getSourcePhotos(source: string): File[] {
    if (source === 'grid' && this.gridUploadBtn.nativeElement.files && this.gridUploadBtn.nativeElement.files.length > 0) {
      return this.gridUploadBtn.nativeElement.files;
    }
    if (source === 'grid2' && this.gridUploadBtn2.nativeElement.files && this.gridUploadBtn2.nativeElement.files.length > 0) {
      return this.gridUploadBtn2.nativeElement.files;
    }
    if (source === 'button' && this.uploadBtn.nativeElement.files && this.uploadBtn.nativeElement.files.length > 0) {
      return this.uploadBtn.nativeElement.files;
    }
    if (source === 'grid' && this.gridUploadBtnFull.nativeElement.files && this.gridUploadBtnFull.nativeElement.files.length > 0) {
      return this.gridUploadBtnFull.nativeElement.files;
    }
    if (source === 'grid2' && this.gridUploadBtn2Full.nativeElement.files && this.gridUploadBtn2Full.nativeElement.files.length > 0) {
      return this.gridUploadBtn2Full.nativeElement.files;
    }
    if (source === 'button' && this.uploadBtnFull.nativeElement.files && this.uploadBtnFull.nativeElement.files.length > 0) {
      return this.uploadBtnFull.nativeElement.files;
    }
    return [];
  }

  verifyDuplicatePhoto(readFile: any): boolean {
    let unique = true;
    this.attachedPhotosSession.forEach(attach => {
      if (attach.content === readFile) {
        unique = false;
      }
    });
    return unique;
  }

  clearPhotoInputs(): void {
    this.gridUploadBtn.nativeElement.value = '';
    this.gridUploadBtn2.nativeElement.value = '';
    this.uploadBtn.nativeElement.value = '';
    this.gridUploadBtnFull.nativeElement.value = '';
    this.gridUploadBtn2Full.nativeElement.value = '';
    this.uploadBtnFull.nativeElement.value = '';
  }

  removeAttachedPhoto(idx: number): void {
    if (this.attachedPhotosSession.length === 0) {
      return;
    }
    this.attachedPhotosSession.splice(idx, 1);
  }

  checkAllPhotos(): void {
    this.attachedPhotosSession.forEach(photo => photo.marked = true);
  }

  uncheckAllPhotos(): void {
    this.attachedPhotosSession.forEach(photo => photo.marked = false);
  }

  togglePhotoManager(state: boolean): void {
    this.setBodyScroll(!state);
    this.showFullPhotoManager = state;
  }

  openUrl(url: string): void {
    window.open(url, '_blank');
  }

  addVideo(): void {
    this.videosArray.push({ url: '' });
  }

  addTour(): void {
    this.toursArray.push({ url: '' });
  }

  removeVideoUrl(idx: number): void {
    this.videosArray.splice(idx, 1);
  }

  removeTourUrl(idx: number): void {
    this.toursArray.splice(idx, 1);
  }

  async verifyFiles(source: string) {
    const filesArray: File[] = this.getSourceFiles(source);
    for (const file of filesArray) {
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (this.allowedExtensionsFile.includes(fileExtension)) {
        if (file.size < 2097153) {
          const icon: string = this.iconExt[fileExtension] || null;
          const readFile = await this.getBase64(file);
          if (this.attachedFilesSession.length < this.maxFiles) {
            if (this.verifyDuplicateFile(readFile)) {
              this.attachedFilesSession.push({
                name: file.name,
                file,
                fileExt: fileExtension,
                icon,
                content_type: file.type,
                content: readFile
              });
            } else {
              this.snackSvc.show('Arquivo duplicado.', 'error');
            }
          } else {
            this.snackSvc.show('Limite de arquivos atingido.', 'error');
          }
        } else {
          this.snackSvc.show('Limite máximo por arquivo é de 2MB.', 'error');
        }
      } else {
        this.snackSvc.show('Tipo de arquivo não permitido.', 'error');
      }
    }
    this.clearFileInputs();
  }

  getSourceFiles(source: string): File[] {
    if (source === 'grid' && this.gridUploadFileBtn.nativeElement.files && this.gridUploadFileBtn.nativeElement.files.length > 0) {
      return this.gridUploadFileBtn.nativeElement.files;
    }
    if (source === 'grid2' && this.gridUploadFileBtn2.nativeElement.files && this.gridUploadFileBtn2.nativeElement.files.length > 0) {
      return this.gridUploadFileBtn2.nativeElement.files;
    }
    if (source === 'button' && this.uploadFileBtn.nativeElement.files && this.uploadFileBtn.nativeElement.files.length > 0) {
      return this.uploadFileBtn.nativeElement.files;
    }
    return [];
  }

  verifyDuplicateFile(readFile: any): boolean {
    let unique = true;
    this.attachedFilesSession.forEach(attach => {
      if (attach.content === readFile) {
        unique = false;
      }
    });
    return unique;
  }

  clearFileInputs(): void {
    this.gridUploadFileBtn.nativeElement.value = '';
    this.gridUploadFileBtn2.nativeElement.value = '';
    this.uploadFileBtn.nativeElement.value = '';
  }

  removeAttachedFile(idx: number): void {
    if (this.attachedFilesSession.length === 0) {
      return;
    }
    this.attachedFilesSession.splice(idx, 1);
  }

  getBase64(baseFile: File): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(baseFile);
      reader.onload = (item: any) => {
        resolve(item.target.result);
      };
      reader.onerror = error => {
        reject(null);
      };
    });
  }

  setBodyScroll(state: boolean) {
    if (state) {
      this.windowService.enable();
    } else {
      this.windowService.disable();
    }
  }
}
